/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2023.

!Changelog

2023
	10-03-2023
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_booking_payments = {};

(function(){

	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {

		/*
		Click: Download
		*/
		$(document).on('click', '.js-invoice-download', function () {
			
			specific_booking_payments.download(
				$(this).data('token')
			);

		});

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	this.download = function (
		_invoice_token
	) {

		/*
		Modal: Open
		*/
		// modal.open('loading');

		/*
		PDF: Download
		*/
		specific_pdf.download(
			_invoice_token
		);

	};
			
}).apply(specific_booking_payments); 